import React, { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { showNotification } from '@mantine/notifications';

import { AppActionType, AppContext } from '../../contexts/app';
import { AuthActionType, AuthContext } from '../../contexts/auth';
import { grp, RouteId } from '../../routes';
import { useNavigateRef } from '../../hooks/use-navigate-ref';
import { useApi } from '../../hooks/use-api';
import { handleNonFormErrors } from '../../helpers/errors';

export const LogoutPage: React.FC = () => {
  const { authDispatch } = useContext(AuthContext);
  const { appDispatch } = useContext(AppContext);
  const { current: navigate } = useNavigateRef();
  const [searchParams] = useSearchParams();

  const [logoutCall] = useApi('auth.logout');

  const redirectTo: RouteId = searchParams.has('redirectTo')
    ? searchParams.get('redirectTo') as RouteId
    : 'login';

  let redirectSearchParams = '';
  if (redirectTo === 'confirm' && searchParams.has('email')) {
    redirectSearchParams = `?email=${encodeURIComponent(searchParams.get('email') as string)}`;
  }

  useEffect(() => {
    const doLogout = async () => {
      try {
        await logoutCall();

        appDispatch({
          type: AppActionType.RESET_STATE,
        });

        authDispatch({
          type: AuthActionType.USER_LOGOUT,
        });

        // TODO: Bu kod geçiş sürecinde kullanılacak. Geçiş süreci bittiğinde kaldırılacak.
        window.localStorage.removeItem('efficense_auth_token');

        navigate({
          pathname: grp(redirectTo),
          search: redirectSearchParams,
        });
      } catch (error) {
        handleNonFormErrors(error, (message) => {
          showNotification({ color: 'red', message });
        });
      }
    };

    doLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>Logout in progress...</div>
  );
};
